module.exports = __webpack_public_path__ + "img/post-template.343ca567.png";